import * as CONST from '../ActionTypes';

const initialState = {
  productList: [],
  product: {},
};

function product(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 商品一覧
    // -----------------
    case CONST.GET_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        productList: action.payload.filter((pr) => pr.product_categories.length > 0),
      };
    case CONST.GET_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        productList: [],
      };
    // -----------------
    // 商品詳細
    // -----------------
    case CONST.GET_PRODUCT_DETAIL_SUCCESS:
      return {
        ...state,
        product: action.payload,
      };
    case CONST.GET_PRODUCT_DETAIL_FAILURE:
      return {
        ...state,
        product: [],
      };

    default:
      return state;
  }
}

export default product;
